export default __webpack_public_path__ + "static/media/457.b93b1320.png";